// src/components/form/btn.js

import React from "react";

export default function Btn({ type, children, disabled = false, className = "", ...props }) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`btn bg-[#F15213] text-white rounded-md p-2 w-full h-[60px] text-lg font-bold hover:bg-[#F15213]/80 transition-all duration-300 shadow-md hover:shadow-lg hover:scale-105 hover:cursor-pointer mb-4 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:shadow-md ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
